import React, { createContext, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

import reducer from './Reducer';
import actions from './Actions';

const initialState = {
  enterprise: null,
  enterpriseId: null,
  plans: null,
  currency: 'USD',
  currencyId: '',
};

const context = createContext();

export function ContextProvider({
  enterpriseId, currency, currencyId, children,
}) {
  initialState.enterpriseId = enterpriseId;
  initialState.currency = currency;
  initialState.currencyId = currencyId;
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => ({
    state, dispatch, actions,
  }), [state, dispatch, actions]);

  return (
    <context.Provider value={value}>
      {children}
    </context.Provider>
  );
}

ContextProvider.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  currencyId: PropTypes.string.isRequired,
};

export const useContext = () => React.useContext(context);
